import { Button, Card, Flex, Text } from "@mantine/core";
import { assertQuizChallenge, getCorrectAnswers, getTotalQuestions } from "@/sales-tools/micro-learning/utils";
import CompletedBadge from "../../../../micro-learning/components/icons/CompletedBadge.svg";
import { ProgressBar } from "../../../../micro-learning/components/ProgressBar";
import type { ContentProps } from "../AnnouncementEndContentFactory";
import { RedWarning } from "../icons/RedWarning";
import classes from "./AnnouncementEndQuizContent.module.css";

export function AnnouncementEndQuizContent({ onDismiss, challenge }: ContentProps) {
    assertQuizChallenge(challenge);
    return (
        <Card w="320px" p={0} bg="dark.5">
            <Flex justify="center">
                <img
                    data-testid="completed-badge-animation"
                    src={CompletedBadge}
                    alt="Completed Badge"
                    height={144}
                    width={144}
                />
            </Flex>
            <Flex direction="column" p="lg" gap="lg" className={classes.background}>
                <Flex direction="column" gap="md">
                    <Flex direction="column" gap="xxs">
                        <Flex gap="3xs">
                            <RedWarning />
                            <Text size="lg" fw="bold">
                                Challenge has ended
                            </Text>
                        </Flex>
                        <Text size="sm">You didn&apos;t quite make it. You&apos;ll get it next time.</Text>
                    </Flex>
                    <ProgressBar
                        currentQuestionNumber={getCorrectAnswers(challenge)}
                        totalNumberOfQuestions={getTotalQuestions(challenge)}
                        progressWidth={272}
                    />
                </Flex>
                <Flex justify="right">
                    <Button h={32} onClick={onDismiss}>
                        Done
                    </Button>
                </Flex>
            </Flex>
        </Card>
    );
}
